const stylesTable = {
  table: {
    width: "100%",
  },
  title: {
    fontSize: "16px",
    color: "#4C4C4C",
    marginTop: "1rem",
    opacity: "0.7",
    textAlign: "center",
    fontFamily: "Raleway, sans-serif",
    fontWeight:600
  },
  column: {
    fontFamily: "Raleway, sans-serif",
    fontSize: "14px",
    color: "darkgray", 
    textAlign: "center",
  },
  a: {
    color: "#9C27B0",
    fontSize: "1rem",
    opacity: "0.7",
    textDecoration: "none",
    display: "inline-block",
    fontFamily: "Raleway, sans-serif",
  },
  icon: {
    color: "#c20000",
    cursor: "pointer",
    opacity: "0.7",
    fontSize:"22px"
  },
};


export default stylesTable;